module.exports = __webpack_public_path__ + "img/error-dark.54b36d09.svg";